import { Iterable } from 'immutable'
export default function stubImmutableIterable() {
  return Iterable([])
}
